export const theme = {
  /* background: '#f5f8fb', */
  fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
  headerBgColor: '#fff',
  headerFontColor: '#fff',
  headerFontSize: '21px',
  botBubbleColor: '#00305a',
  botFontColor: '#fff',
  userBubbleColor: '#fff',
  userFontColor: '#8f8e91',
};
